import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminDeleteCustomsError = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      try {
        return apiClient.customsError.deleteCustomsError.mutation({ params: { id } });
      } catch (error) {
        showErrorToast(error, 'Failed to delete customs error');
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-customs-errors-list'] });
      toast.success('Customs error deleted successfully');
    },
  });
};
